/**
 * Иконки макета-эталона docs/design/frontend-v2 (prototype.js, icons): тот же контур
 * 24×24, обводка 1.6, скругления. Пути перенесены без изменений.
 */

import type { ReactNode, SVGAttributes } from 'react';

const PATHS = {
	book: (
		<>
			<path d="M12 5c-3-2-6-2-9-1v15c3-1 6-1 9 1m0-15c3-2 6-2 9-1v15c-3-1-6-1-9 1V5Z" />
		</>
	),
	overview: (
		<>
			<rect x="3" y="3" width="7" height="7" rx="1.5" />
			<rect x="14" y="3" width="7" height="7" rx="1.5" />
			<rect x="3" y="14" width="7" height="7" rx="1.5" />
			<rect x="14" y="14" width="7" height="7" rx="1.5" />
		</>
	),
	map: (
		<>
			<circle cx="5" cy="5" r="2" />
			<circle cx="19" cy="6" r="2" />
			<circle cx="9" cy="19" r="2" />
			<circle cx="19" cy="18" r="2" />
			<path d="m7 5 10 1M6 7l2 10m3 2 6-1M18 8v8M11 17l6-9" />
		</>
	),
	box: (
		<>
			<path d="m12 3 9 5v9l-9 5-9-5V8l9-5Z" />
			<path d="m3 8 9 5 9-5M12 13v9M7 5.8l9 5" />
		</>
	),
	database: (
		<>
			<ellipse cx="12" cy="5" rx="8" ry="3" />
			<path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" />
		</>
	),
	api: (
		<>
			<path d="m8 6-6 6 6 6m8-12 6 6-6 6M14 3l-4 18" />
		</>
	),
	tags: (
		<>
			<path d="M3 3h8l10 10-8 8L3 11V3Z" />
			<circle cx="7.5" cy="7.5" r="1" />
		</>
	),
	groups: (
		<>
			<rect x="3" y="4" width="7" height="7" rx="1" />
			<rect x="14" y="4" width="7" height="7" rx="1" />
			<rect x="8.5" y="15" width="7" height="7" rx="1" />
			<path d="M6.5 11v7H8m9.5-7v7H16" />
		</>
	),
	shield: (
		<>
			<path d="M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6l-9-4Z" />
			<path d="m8 12 3 3 5-6" />
		</>
	),
	alert: (
		<>
			<path d="m12 3 10 18H2L12 3Z" />
			<path d="M12 9v5m0 3v.5" />
		</>
	),
	path: (
		<>
			<circle cx="5" cy="5" r="2" />
			<circle cx="19" cy="19" r="2" />
			<path d="M7 5h9a4 4 0 0 1 0 8H8a3 3 0 0 0 0 6h9" />
		</>
	),
	ai: (
		<>
			<path d="m12 2 2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5L12 2Z" />
		</>
	),
	sensor: (
		<>
			<rect x="3" y="4" width="18" height="6" rx="2" />
			<rect x="3" y="14" width="18" height="6" rx="2" />
			<path d="M7 7h.01M7 17h.01M11 7h6m-6 10h6" />
		</>
	),
	plug: (
		<>
			<path d="M8 3v5m8-5v5M5 8h14v3a7 7 0 0 1-14 0V8Zm7 10v4" />
		</>
	),
	report: (
		<>
			<path d="M14 2H5v20h14V7l-5-5Z" />
			<path d="M14 2v5h5M8 12h8M8 16h8" />
		</>
	),
	team: (
		<>
			<circle cx="9" cy="8" r="3" />
			<path d="M3 21v-3a6 6 0 0 1 12 0v3m1-16a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 4v3" />
		</>
	),
	lock: (
		<>
			<rect x="5" y="10" width="14" height="11" rx="2" />
			<path d="M8 10V6a4 4 0 0 1 8 0v4M12 14v3" />
		</>
	),
	arrow: (
		<>
			<path d="M4 12h15m-6-6 6 6-6 6" />
		</>
	),
	chevron: (
		<>
			<path d="m9 5 7 7-7 7" />
		</>
	),
	down: (
		<>
			<path d="m6 9 6 6 6-6" />
		</>
	),
	search: (
		<>
			<circle cx="10.5" cy="10.5" r="6.5" />
			<path d="m16 16 5 5" />
		</>
	),
	export: (
		<>
			<path d="M12 2v13m-5-5 5 5 5-5M4 15v6h16v-6" />
		</>
	),
	calendar: (
		<>
			<rect x="3" y="5" width="18" height="16" rx="2" />
			<path d="M7 2v6m10-6v6M3 11h18M7 15h3m4 0h3" />
		</>
	),
	close: (
		<>
			<path d="m6 6 12 12M18 6 6 18" />
		</>
	),
	list: (
		<>
			<path d="M4 5h16M4 10h16M4 15h16M4 20h16" />
		</>
	),
	clock: (
		<>
			<circle cx="12" cy="12" r="9" />
			<path d="M12 6v6l4 2" />
		</>
	),
	check: (
		<>
			<path d="m5 12 4 4L19 6" />
		</>
	),
	globe: (
		<>
			<circle cx="12" cy="12" r="9" />
			<ellipse cx="12" cy="12" rx="4" ry="9" />
			<path d="M3 12h18" />
		</>
	),
	sort: (
		<>
			<path d="M8 4v16m-4-4 4 4 4-4m4-12v16m-4-12 4-4 4 4" />
		</>
	),
} satisfies Record<string, ReactNode>;

export type WorkspaceIconName = keyof typeof PATHS;

interface WorkspaceIconProps extends SVGAttributes<SVGSVGElement> {
	name: WorkspaceIconName;
	size?: number;
}

export function WorkspaceIcon({ name, size = 18, ...rest }: WorkspaceIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			{...rest}
		>
			{PATHS[name]}
		</svg>
	);
}
